import { useTranslation } from "react-i18next";
import CarDetailSection from "../../../cars/components/cardetails/CarDetailSection";

function CustomerChangeLogTab() {
    const { t } = useTranslation("customers");

    return (
        <CarDetailSection
            title={t("customerDetail.changeLog")}
            empty
            emptyDescription={t("customerDetail.changeLogComingSoon")}
            embedded
            className="!mt-0"
        />
    );
}

export default CustomerChangeLogTab;
